<div>
    <!-- <button mat-raised-button color="primary" (click)="getSQL()">Apply</button> -->
    <app-rule-builder></app-rule-builder>
</div>